import { createFetchModule } from '../fetch';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

export default {
    namespaced: true,
    
    state: () => ({
        query: null
    }),
    
    getters,
    mutations,
    actions,
    
    modules: {
        listReq: createFetchModule(
            { url: `${BEST_ONE_API_FRONTEND}/tire/tire-search-by-vehicle/` }
        )
    }
};